import { render, staticRenderFns } from "./moreWarn.vue?vue&type=template&id=75dfa381&scoped=true&"
import script from "./moreWarn.vue?vue&type=script&lang=js&"
export * from "./moreWarn.vue?vue&type=script&lang=js&"
import style0 from "./moreWarn.vue?vue&type=style&index=0&id=75dfa381&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dfa381",
  null
  
)

export default component.exports